const AIMS_FLAVORS = {
  FIT: 'fit',
  FIT_1000w: 'fit-1000w',
  FIT_1120w: 'fit-1120w',
  FIT_1240w: 'fit-1240w',
  FIT_1500w: 'fit-1500w',
  FIT_1520w: 'fit-1520w',
  FIT_2000w: 'fit-2000w',
  FIT_260w: 'fit-260w',
  FIT_320w: 'fit-320w',
  FIT_360w: 'fit-360w',
  FIT_560w: 'fit-560w',
  FIT_660w: 'fit-660w',
  FIT_678w: 'fit-678w',
  FIT_720w: 'fit-720w',
  FIT_760w: 'fit-760w',
  FIT_860w: 'fit-860w',
  FIT_880w: 'fit-880w',
  FOCAL_140x70: 'focal-140x70', // Not real flavors, just for tests
  FOCAL_150x75: 'focal-150x75', // Not real flavors, just for tests
  FOCAL_290x145: 'focal-290x145', // Not real flavors, just for tests
  FOCAL_479x479: 'focal-479x479', // Not real flavors, just for tests
  FOCAL_899x899: 'focal-899x899', // Not real flavors, just for tests
  FOCAL_300x150: 'focal-300x150', // Not real flavors, just for tests
  FOCAL_900x900: 'focal-900x900', // Not real flavors, just for tests
  FOCAL_1000x500: 'focal-1000x500',
  FOCAL_1000x563: 'focal-1000x563',
  FOCAL_1000x600: 'focal-1000x600',
  FOCAL_100x100: 'focal-100x100',
  FOCAL_1040x520: 'focal-1040x520', // Retina for 520x260
  FOCAL_1120x560: 'focal-1120x560', // Retina for 560x230
  FOCAL_1160x580: 'focal-1160x580',
  FOCAL_1200x600: 'focal-1200x600', // Retina for 600x300
  FOCAL_120x120: 'focal-120x120',
  FOCAL_1240x620: 'focal-1240x620',
  FOCAL_1240x800: 'focal-1240x800',
  FOCAL_130x130: 'focal-130x130',
  FOCAL_134x134: 'focal-134x134',
  FOCAL_147x147: 'focal-147x147',
  FOCAL_1520x760: 'focal-1520x760', // Retina for 760x380
  FOCAL_160x160: 'focal-160x160',
  FOCAL_170x170: 'focal-170x170',
  FOCAL_180x180: 'focal-180x180', // Retina for 90x90
  FOCAL_190x190: 'focal-190x190',
  FOCAL_200x100: 'focal-200x100',
  FOCAL_200x200: 'focal-200x200', // Retina for 100x100
  FOCAL_220x110: 'focal-220x110',
  FOCAL_230x230: 'focal-230x230',
  FOCAL_240x240: 'focal-240x240',
  FOCAL_260x130: 'focal-260x130',
  FOCAL_260x260: 'focal-260x260',
  FOCAL_276x276: 'focal-276x276',
  FOCAL_280x140: 'focal-280x140',
  FOCAL_282x141: 'focal-282x141',
  FOCAL_294x294: 'focal-294x294', // Retina for 147x147
  FOCAL_300x300: 'focal-300x300',
  FOCAL_320x160: 'focal-320x160',
  FOCAL_320x320: 'focal-320x320',
  FOCAL_348x348: 'focal-348x348',
  FOCAL_360x180: 'focal-360x180',
  FOCAL_360x360: 'focal-360x360',
  FOCAL_360x700: 'focal-360x700',
  FOCAL_380x190: 'focal-380x190',
  FOCAL_380x380: 'focal-380x380',
  FOCAL_400x200: 'focal-400x200', // Retina for 200x100
  FOCAL_440x220: 'focal-440x220',
  FOCAL_440x440: 'focal-440x440',
  FOCAL_460x230: 'focal-460x230',
  FOCAL_460x460: 'focal-460x460',
  FOCAL_520x260: 'focal-520x260',
  FOCAL_552x276: 'focal-552x276',
  FOCAL_560x280: 'focal-560x280',
  FOCAL_560x560: 'focal-560x560',
  FOCAL_564x282: 'focal-564x282',
  FOCAL_580x290: 'focal-580x290',
  FOCAL_580x580: 'focal-580x580',
  FOCAL_600x300: 'focal-600x300',
  FOCAL_600x333: 'focal-600x333',
  FOCAL_60x60: 'focal-60x60',
  FOCAL_630x630: 'focal-630x630',
  FOCAL_640x320: 'focal-640x320', // Retina for 320x160
  FOCAL_678x339: 'focal-678x339',
  FOCAL_696x348: 'focal-696x348',
  FOCAL_720x360: 'focal-720x360',
  FOCAL_758x379: 'focal-758x379',
  FOCAL_760x1000: 'focal-760x1000',
  FOCAL_760x320: 'focal-760x320',
  FOCAL_760x380: 'focal-760x380',
  FOCAL_760x428: 'focal-760x428',
  FOCAL_760x760: 'focal-760x760',
  FOCAL_80x80: 'focal-80x80',
  FOCAL_860x430: 'focal-860x430',
  FOCAL_860x484: 'focal-860x484',
  FOCAL_870x435: 'focal-870x435',
  FOCAL_880x700: 'focal-880x700',
  FOCAL_90x90: 'focal-90x90',
  FOCAL_920x460: 'focal-920x460',
  FOCAL_920x480: 'focal-920x480',
  MINI_PLAYER_TEASE_140x80: 'mini-player-tease-140x80',
  FOCAL: 'focal',
  SOCIAL_SHARE_DEFAULT: 'social_share_1024x768_scale',
  SOCIAL_SHARE_OG_TODAY: 'social_share_1200x630_center',
  SOCIAL_SHARE_OG: 'nbcnews-fp-1200-630',
  SOCIAL_SHARE_TWITTER_TODAY: 'social_share_1024x512_center',
  SOCIAL_SHARE_TWITTER: 'nbcnews-fp-1024-512',
};
export const AIMS_FLAVOR_VALUES = Object.values(AIMS_FLAVORS);

export default AIMS_FLAVORS;
